<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">TRACKING</h1>
			<p class="text-left didascalia-bertazzoni mb-3">Tracking status legend:</p>
			<div class="row text-left mb-2">
				<div class="col-12">
					<img src="assets/img/received.svg" class=" action-icon mx-2 mb-2" title="RECEIVED" />
					<span class="mr-4">Received</span>

					<img src="assets/img/confirmed.svg" class=" action-icon mx-2 mb-2" title="CONFIRMED" />
					<span class="mr-3">Confirmed</span>

					<img src="assets/img/planned.svg" class=" action-icon mx-2 mb-2" title="PLANNED" />
					<span class="mr-4">Availability Week</span>

					<img src="assets/img/in-stock.svg" class=" action-icon mx-2 mb-2" title="IN STOCK" />
					<span class="mr-4">In Stock</span>

					<img src="assets/img/shipment.svg" class=" action-icon mx-2" title="WEEK / YEAR" />
					<span class="mr-3">Expected Shipping Week</span>

					<img src="assets/img/shipped.svg" class=" action-icon mx-2 mb-2" title="IN TRANSIT" />
					<span class="mr-3">In Transit</span>

					<img src="assets/img/home.svg" class=" action-icon mx-2" title="DELIVERED" />
					<span class="mr-3">Delivered *</span>
				</div>

				<div class="col-12 ml-2 mt-2">
					<p>* The yellow dot means that the shipment has been partially shipped</p>
				</div>
			</div>
			<div class="row text-left mb-2">
				<div class="col-12">
					<p class="text-left didascalia-bertazzoni mb-2">Export in excel:</p>
				</div>
			</div>
			<div class="row text-left mb-5">
				<div class="col d-flex">
					<div class="mt-3 mt-lg-0 d-flex">
						<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" (click)="export(check.checked)">DOWNLOAD</button>
					</div>
					<div class="ml-lg-4 mt-3 mt-lg-0 d-flex pt-2">
						<h6 class="mb-0">Export only open orders:</h6>
						<div class="custom-control custom-checkbox" style="padding-top: 0.15rem !important;">
							<input class="checkbox" type="checkbox" id="check-open" value="" name="filtroDaConfermare" #check />
						</div>
					</div>
				</div>
				<div class="col d-flex text-right mr-3">
					<p class="ml-auto mt-2 mr-2">Year:</p>
					<div class="form-group mb-0">
						<select class="minimal rounded-0 border-black" name="anno" [(ngModel)]="filtroAnno" (change)="aggiornaTracking()">
							<option *ngFor="let anno of anni" [value]="anno">{{anno}}</option>
						</select>
					</div>
				</div>
				<div class="col d-flex text-right" *ngIf="isAdminOrBackoffice">
					<p class="ml-auto mt-2">Search by customer:</p>
					<div class="custom-control custom-checkbox pl-2" style="padding-top: 0.15rem !important;">
						<input class="rounded-0 form-bertazzoni white" type="text" value="" name="filtroCliente" (input)="filtraCliente($event)" />
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-5">
			<div class="col-12">
				<table #dt datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" *ngIf="righeOrdine.length > 0">
					<thead #header>
						<tr>
							<th class="all" *ngIf="isAdminOrBackoffice">User</th>
							<th class="all">Order nr.</th>
							<th class="all">Order nr. Bertazzoni</th>
							<th class="all">Row nr.</th>
							<th class="all">PO</th>
							<th class="all">Prd. Code</th>
							<th class="all">Qty</th>
							<th class="all">Open Qty</th>
							<th class="all">
								<img src="assets/img/received.svg" class="tracking action-icon all" title="RECEIVED" />
							</th>
							<th class="all">
								<img src="assets/img/confirmed.svg" class="tracking action-icon" title="CONFIRMED" />
								<span class="action-mobile">CONFIRMED</span>
							</th>
							<th class="all">
								<img src="assets/img/planned.svg" class="tracking action-icon" title="AVAILABILITY WEEK" />
								<span class="action-mobile">AVAILABILITY WEEK</span>
							</th>
							<th class="all">
								<img src="assets/img/in-stock.svg" class="tracking action-icon" title="IN STOCK" />
								<span class="action-mobile">IN STOCK</span>
							</th>
							<th class="all">
								<img src="assets/img/shipment.svg" class="tracking action-icon" title="EXPECTED SHIPPING WEEK" />
								<span class="action-mobile">EXPECTED SHIPPING WEEK</span>
							</th>
							<th class="all">
								<img src="assets/img/shipped.svg" class="tracking action-icon" title="IN TRANSIT" />
								<span class="action-mobile">IN TRANSIT</span>
							</th>
							<th class="all">
								<img src="assets/img/home.svg" class="tracking action-icon" title="DELIVERED" />
								<span class="action-mobile">DELIVERED</span>
							</th>
							<th class="all">Docs</th>
							<th hidden>nDDT</th>
							<th hidden>nFattura</th>
							<th hidden>nSigillo</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let riga of righeOrdine">
							<td *ngIf="isAdminOrBackoffice">{{riga.utente.cliente?.ragioneSociale}}</td>
							<td>{{riga.nOrdine ? riga.nOrdine :'N/D'}}</td>
							<td>{{riga.nOrdineSimag && riga.nOrdineSimag != 0 ? riga.nOrdineSimag :'N/D'}}</td>
							<td>{{riga.progressivoRiga}}</td>
							<td>{{riga.rifOrdineCliente}}</td>
							<td>{{riga.prodottoCommerciale.codiceCommerciale}}</td>
							<td>{{riga.quantita}}</td>
							<td>{{riga.quantitaAperta}}</td>
							<td>
								<p style="display: none;">{{riga.progressivoStato}}</p>
								<div class="tracking-icon" [class.ok]="riga.progressivoStato > 0"><span *ngIf="riga.progressivoStato > 0"></span></div>
							</td>
							<td>
								<p style="display: none;">{{riga.progressivoStato > 1}}</p>
								<div class="tracking-icon" [class.ok]="riga.progressivoStato > 1"><span *ngIf="riga.progressivoStato > 1"></span></div>
							</td>
							<td>
								<p style="display: none;">
									{{ riga.dataSpedizionePrevista && riga.dataSpedizionePrevista !== '0' ?  (riga.dataSpedizionePrevista | amParse :'YYYYMMDD' | amDateFormat:'W / GGGG') : 'N/D' }}
								</p>
								{{ riga.dataSpedizionePrevista && riga.dataSpedizionePrevista !== '0' ?  (riga.dataSpedizionePrevista | amParse :'YYYYMMDD' | amDateFormat:'W / GGGG') : 'N/D' }}
							</td>
							<td>
								<p style="display: none;">{{riga.progressivoStato > 5}}</p>
								<div class="tracking-icon" [class.ok]="riga.progressivoStato > 5"><span *ngIf="riga.progressivoStato > 5"></span></div>
							</td>
							<td>
								<p style="display: none;">
									{{ riga.dataConfermata && riga.dataConfermata !== '0' ? (riga.dataConfermata | amParse :'YYYYMMDD' | amDateFormat:'W / GGGG') : 'N/D' }}
								</p>
								{{ riga.dataConfermata && riga.dataConfermata !== '0' ? (riga.dataConfermata | amParse :'YYYYMMDD' | amDateFormat:'W / GGGG') : 'N/D' }}
							</td>
							<td>
								<p style="display: none;">{{riga.progressivoStato > 6}}</p>
								<div class="tracking-icon" [class.ok]="riga.progressivoStato > 6"><span *ngIf="riga.progressivoStato > 6"></span></div>
							</td>
							<td>
								<p style="display: none;">{{riga.progressivoStato === 8 ? 'yellow' : riga.progressivoStato === 9 ? 'ok' : ''}}</p>
								<div
									class="tracking-icon"
									[ngClass]="riga.progressivoStato === 8 ? 'yellow' : riga.progressivoStato === 9 ? 'ok' : ''"></div>
							</td>
							<td>
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0 px-2"
									(click)="open(content, riga)"
									*ngIf="riga.documentiDiEvasione.length > 0">
									OPEN
								</button>
							</td>
							<td hidden>
								<span *ngFor="let ele of riga.documentiDiEvasione">{{ele.nDDT}}</span>
							</td>
							<td hidden>
								<span *ngFor="let ele of riga.documentiDiEvasione">{{ele.nFattura}}</span>
							</td>
							<td hidden>
								<span *ngFor="let ele of riga.documentiDiEvasione">{{ele.nSigillo}}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="row" *ngIf="righeOrdine.length <= 0">
					<div class="col-12 text-center">No order found.</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #content let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Evasion Documents</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="border p-3 mb-4">
			<table datatable [dtOptions]="{paging: false, searching: false}" class="row-border hover">
				<thead>
					<tr>
						<th>Transport Document</th>
						<th>Transport Document date</th>
						<th>Invoice Number</th>
						<th>Invoice Date</th>
						<th>Container nr.</th>
						<th>DDT qty.</th>
						<th>Seal nr.</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let dde of rigaSelected.documentiDiEvasione">
						<td>{{dde.nDDT}}</td>
						<td>{{(dde.dataDDT | amParse :'YYYYMMDD' | amDateFormat:'MM/DD/YYYY')}}</td>
						<td>{{dde.nFattura}}</td>
						<td>{{(dde.dataFattura | amParse :'YYYYMMDD' | amDateFormat:'MM/DD/YYYY')}}</td>
						<td>{{dde.nContainer}}</td>
						<td>{{dde.quantitaDDT}}</td>
						<td>{{dde.nSigillo}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>
